export const AppConfig =
{
  email: "healthpromotion@nichs.org.uk",
  web: "https://nichs.org.uk",
  tel: "028 9032 0184",
  signature: "NICHS Team",
  preAssessment: true,
  preAssessmentUri: "https://pre.wellcheck.nichs.org.uk/"
};